const COMMENTS = [
  {
    text: '用了被窝影院三年了，资源真的全，更新也快。最近暑期档大片基本都能第一时间看到高清版，画质流畅不卡，比好多收费平台都强。推荐给身边所有追剧的朋友了！',
    author: '电影发烧友阿强',
    source: '资深用户',
    tag: '资源齐全',
  },
  {
    text: '被窝影院APP简直是我的通勤救星。地铁上缓存两部剧，到公司刚好看完。界面清爽没广告，高清画质看着就是舒服。最新地址换了几次都第一时间找到了，从不掉队。',
    author: '追剧小达人',
    source: 'APP用户',
    tag: '体验极佳',
  },
  {
    text: '作为一个悬疑片爱好者，被窝影院的分类和推荐真的太懂我了。豆瓣高分悬疑剧基本都能找到，还有不少冷门佳作。高清在线看全集不缓冲，周末窝在被窝里一口气刷完一部剧，太幸福了。',
    author: '悬疑控老林',
    source: '两年用户',
    tag: '内容优质',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            用户反馈
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            影迷们怎么说
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {COMMENTS.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 relative"
            >
              <span className="absolute top-4 right-4 px-2.5 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                {c.tag}
              </span>
              <div className="flex items-center gap-1 mb-3 text-accent-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{c.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-user-line text-primary-600 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{c.author}</div>
                  <div className="text-xs text-foreground-400">{c.source}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}